export function useEditorReset({
  setImg,
  setOriginalFile,
  setPieces,
  setScale,
  setOffset,
  setFileName,
  setQualityModal,
  canvasRef,
  fileInputRef,
}) {
  const resetEditor = () => {
    setImg(null);
    setOriginalFile(null);
    setPieces([]);

    setScale(1);
    setOffset({ x: 0, y: 0 });

    setFileName("");

    setQualityModal({
      open: false,
      type: null,
    });

    const canvas = canvasRef.current;

    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return { resetEditor };
}
